// extracted by mini-css-extract-plugin
module.exports = {"ui":"x_P","hi":"x_bf","hi____hidden":"x_bg","txt":"x_bh","ui____minimized":"x_Q"};